import { useState, useCallback, useContext } from 'react';
import axios from 'axios';
import { ConfigContext } from '../components/shared/ConfigContext';

// Lazily fetched (not on mount) — the workspace switcher is the only
// consumer today, and it only needs this list once the menu is opened.
const useMemberships = () => {
  const config = useContext(ConfigContext);
  const [memberships, setMemberships] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchMemberships = useCallback(() => {
    if (!config?.backendUrl) return;
    setLoading(true);
    setError(false);
    axios.get(`${config.backendUrl}/me/memberships`)
      .then((res) => setMemberships(res.data))
      .catch((err) => {
        console.error('Error fetching memberships', err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [config]);

  return { memberships, loading, error, fetchMemberships };
};

export default useMemberships;
